export default function DcoAssetsService($http, $q) {
  return {
    fetch
  };

  function fetch(dcoUrl) {
    // we use this long form to explicitly unset the X-CSRF-Token,
    // which breaks jivox requests when included
    const reqOptions = {
      method: 'GET',
      url: dcoUrl,
      headers: {
        'X-CSRF-Token': undefined
      }
    };
    return $http(reqOptions).then(({ data }) => {
      if (!data.assets || !data.assets.length) {
        return $q.reject(new Error('No assets in DCO response'));
      }

      return buildCreative(data.assets);
    });
  }

  function buildCreative(assets) {
    const creative = {};

    assets.forEach(asset => {
      if (asset.title) {
        handleTitleAsset(asset);
      } else if (asset.img) {
        handleImageAsset(asset);
      } else if (asset.data) {
        handleDataAsset(asset);
      } else if (asset.link) {
        handleLinkAsset(asset);
      }
    });

    function handleTitleAsset({ title }) {
      creative.headline = title.text;
    }

    function handleImageAsset({ img }) {
      if (img.type === 1) {
        creative.brandLogoUrl = img.url;
      } else if (img.type === 3) {
        creative.thumbnailUrl = img.url;
      }
    }

    function handleDataAsset({ data }) {
      if (data.type === 1) {
        creative.advertiser = data.value;
      } else if (data.type === 2) {
        creative.description = data.value;
      }
    }

    function handleLinkAsset({ link }) {
      creative.mediaUrl = link.url;
    }

    return creative;
  }
}

DcoAssetsService.$inject = ['$http', '$q'];
